import { render, staticRenderFns } from "./WallGuestListBlock.vue?vue&type=template&id=f8d1a984"
import script from "./WallGuestListBlock.vue?vue&type=script&lang=js"
export * from "./WallGuestListBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports